// Used for caching the list of templatetypes

import $api from '@/services/api';

export default {
  namespaced: true,
  state: {
    list: [],
    loading: false,
  },
  getters: {
    getLoading: (state) => {
      return state.loading;
    },
    getTemplateTypes: (state) => {
      return state.list;
    },
    getTemplateType: (state) => (templateId) => {
      return state.list.find((template) => template.id === templateId) || null;
    },
  },
  mutations: {
    setTemplateTypeList(state, val) {
      state.list = val;
    },
    setLoading(state, val) {
      state.loading = val;
    },
  },
  actions: {
    ensure({ state, dispatch }) {
      if (!state.list.length) {
        dispatch('fetch');
      }
    },
    // Load the device details and templates for the device
    async fetch({ state, commit }) {
      if (state.loading) return;
      commit('setLoading', true);

      try {
        const templateTypes = await $api.get('/v1/common/templatetypes');
        templateTypes.sort((a, b) => a.name.localeCompare(b.name));
        commit('setTemplateTypeList', templateTypes);
      } catch (err) {
        commit('setTemplateTypeList', []);
      }
      commit('setLoading', false);
    },
  },
};
